<template>
    <v-row>
        <v-col
            sm="12"
            md="8"
            offset-md="2"
        >
            <v-card>
                <v-card-title class="primary--text">
                    Solicitação de Pagamento de Devolução
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        @submit.prevent="enviarSolicitacao"
                    >
                        <v-text-field
                            v-model="form.CNPJ"
                            v-mask="'##.###.###/####-##'"
                            outlined
                            label="CNPJ"
                            :rules="[$rules.required, $rules.cnpj]"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.RAZAO_SOCIAL"
                            outlined
                            label="Razão Social"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-row>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.NOTA_FISCAL"
                                    outlined
                                    label="Nota Fiscal"
                                    :rules="[$rules.required]"
                                    maxlength="10"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.NOTA_FISCAL_SERIE"
                                    outlined
                                    label="Nota Fiscal - Série"
                                    maxlength="10"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.DATA_EMISSAO"
                                    v-mask="'##/##/####'"
                                    outlined
                                    label="Data de Emissão"
                                    :rules="[$rules.required, $rules.brazilDate, $rules.brazilDatePast()]"
                                    maxlength="10"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.VALOR"
                                    v-money="money"
                                    outlined
                                    label="Valor"
                                    prefix="R$"
                                    :rules="[$rules.required, validateMoney]"
                                    validate-on-blur
                                    maxlength="100"
                                />
                            </v-col>
                        </v-row>

                        <v-text-field
                            v-model="form.CONTATO"
                            outlined
                            label="Contato"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.TELEFONE"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            outlined
                            label="Telefone"
                            :rules="[$rules.required]"
                            maxlength="100"
                        />

                        <v-text-field
                            v-model="form.EMAIL"
                            outlined
                            label="E-mail"
                            type="email"
                            :rules="[$rules.required, $rules.email]"
                            maxlength="100"
                        />

                        <v-select
                            v-model="form.BANCO"
                            outlined
                            label="Banco"
                            :rules="[$rules.required]"
                            :items="bancosList"
                        />

                        <v-row>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.AGENCIA"
                                    outlined
                                    label="Agência"
                                    :rules="[$rules.required]"
                                    maxlength="100"
                                />
                            </v-col>
                            <v-col
                                class="py-0"
                                cols="12"
                                sm="6"
                            >
                                <v-text-field
                                    v-model="form.CONTA_CORRENTE"
                                    outlined
                                    label="Conta Corrente da Empresa"
                                    :rules="[$rules.required]"
                                    maxlength="100"
                                />
                            </v-col>
                        </v-row>

                        <v-file-input
                            v-model="form.FILE_NFD"
                            outlined
                            label="Anexo"
                            prepend-icon="mdi-file-outline"
                            show-size
                            :accept="$root.config.FILE_ALLOWED_EXTENSIONS"
                            :rules="[$rules.required, $rules.fileSize($root.config.FILE_MAX_SIZE), $rules.fileExtension($root.config.FILE_ALLOWED_EXTENSIONS)]"
                        />

                        <v-layout justify-center>
                            <v-btn
                                color="primary"
                                type="submit"
                            >
                                Enviar Solicitação
                            </v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import { VMoney } from 'v-money';
    import bancos from '../../helpers/bancos.json';
    import api from '../../services/api';

    export default {
        directives: { money: VMoney },

        data() {
            return {
                form: {
                    CNPJ: null,
                    RAZAO_SOCIAL: null,
                    NOTA_FISCAL: null,
                    NOTA_FISCAL_SERIE: null,
                    DATA_EMISSAO: null,
                    VALOR: null,
                    CONTATO: null,
                    TELEFONE: null,
                    EMAIL: null,
                    BANCO: null,
                    AGENCIA: null,
                    CONTA_CORRENTE: null,
                    FILE_NFD: null
                },

                money: {
                    precision: 2,
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    masked: false
                }
            };
        },

        computed: {
            bancosList() {
                return bancos;
            }
        },

        methods: {
            validateMoney(value) {
                if (value) {
                    return value !== '0,00' || 'Valor inválido';
                }

                return true;
            },

            async enviarSolicitacao() {
                try {
                    if (this.$refs.form.validate()) {
                        await api.saveSolPagamento(this.form);

                        this.$refs.form.reset();

                        this.$root.$emit('message', { text: 'Sua solicitação foi enviada com sucesso!', color: 'success' });
                    }
                } catch (error) {
                    let message = 'Erro ao salvar a solicitação.';

                    if (error.response && error.response.data && error.response.data.message) {
                        message = error.response.data.message;
                    }

                    this.$root.$emit('message', { text: message, color: 'error' });
                }
            }
        }
    };
</script>